import { useEffect, useState } from 'react';

export const useMobilians = (isPay) => {
  useEffect(() => {
    window.addEventListener('message', receiveMessage);
    return () => window.removeEventListener('message', receiveMessage);
  }, []);

  const [mobilians, setMobilians] = useState(null);

  const handleMobiliansOpen = () => {
    if( !isPay ) {
      const left = screen.width / 2 - 436 / 2;
      const top = screen.height / 2 - 570 / 2;
      const popup = window.open(
        '/interface/mobilians-information',
        'mobilians',
        `width=436,height=570,top=${top},left=${left},toolbar=no,menubar=no,scrollbars=no,resizable=yes`
      );

      popup.focus();
    } else {
      const left = screen.width / 2 - 436 / 2;
      const top = screen.height / 2 - 570 / 2;
      const popup = window.open(
        '/interface/mobilians-hp-information',
        'mobilians',
        `width=436,height=570,top=${top},left=${left},toolbar=no,menubar=no,scrollbars=no,resizable=yes`
      );

      popup.focus();
    }



  };

  const receiveMessage = (event) => {
    if (event.origin === window.location.origin) {
      if (event.data.name) {
        const convertedData = {
          ...event.data,
          name: decodeURI(event.data.name),
          cellNo: decodeURI(event.data.cellNo),
          sex: decodeURI(event.data.sex),
          birthDate: decodeURI(event.data.birthDate),
          isForeigner: decodeURI(event.data.isForeigner),
          tradeId: decodeURI(event.data.tradeId),
        };
        setMobilians(convertedData);
      }
    }
  };

  useEffect(() => {}, [mobilians]);

  const resetMobilians = () => setMobilians(null);

  return { mobilians, resetMobilians, handleMobiliansOpen };
};
